/** Must match backend `YOGA_SCHOOL_LEGAL_VERSION`. */
export const YOGA_SCHOOL_LEGAL_VERSION = '2025-03'

export const SCHOOL_LEGAL_PAGE_PATH = '/legal'
